module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#close",
      toString: function () {
        return this.url;
      }
    }